import clsx from 'clsx';

import { WorkOrderAssetTreeType } from '@atom/types/work';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import classes from '../workOrderDetailPdfReport.module.css';

enum RatingLabels {
  RATING_NUMBER = 'Rating Number',
  REPAIR_PRIORITY = 'Repair Priority',
  REPAIR_RECOMMENDATIONS = 'Repair Recommendations',
}

interface Props {
  workOrderAsset: WorkOrderAssetTreeType;
}

const RecommendationTextbox = ({ workOrderAsset }: Props) => {
  const renderRatingDetails = label => {
    const ratingsElementGroups = workOrderAsset.elementGroups.filter(
      elementGroup => elementGroup.name === 'Ratings',
    );
    const elements = ratingsElementGroups[0]?.elements;

    return elements?.map(element =>
      element.attributeGroups.map(attributeGroup =>
        attributeGroup.attributes.map(
          key =>
            element.attributes[key].name === label && (
              <div>
                {attributeDisplayUtility.display(
                  element.attributes[key].value,
                  element.attributes[key].dataType,
                  element.attributes[key].unit,
                  !!element.attributes[key].changeId,
                  element.attributes[key].newValue,
                )}
              </div>
            ),
        ),
      ),
    );
  };

  return (
    <>
      <div className={classes.headerTitle} style={{ margin: 0 }}>
        Recommendation
      </div>
      <div className={clsx(classes.content, classes.row)}>
        <div style={{ width: '15rem' }}>
          <div className={classes.tableHeader}>
            {RatingLabels.RATING_NUMBER}
          </div>
          {renderRatingDetails(RatingLabels.RATING_NUMBER)}
        </div>
        <div style={{ width: '15rem' }}>
          <div className={classes.tableHeader}>
            {RatingLabels.REPAIR_PRIORITY}
          </div>
          {renderRatingDetails(RatingLabels.REPAIR_PRIORITY)}
        </div>
        <div style={{ width: '18.75rem' }}>
          <div className={classes.tableHeader}>
            {RatingLabels.REPAIR_RECOMMENDATIONS}
          </div>
          {renderRatingDetails(RatingLabels.REPAIR_RECOMMENDATIONS)}
        </div>
      </div>
    </>
  );
};

export default RecommendationTextbox;
